import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSettings } from '../lib/api';

const SettingsContext = createContext(null);

const DEFAULTS = {
  hero_images: [
    'https://images.unsplash.com/photo-1722452848316-c6c26ebeeb09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBnb2xmJTIwU3BhaW58ZW58MHx8fHwxNzc5ODE4MzQ0fDA&ixlib=rb-4.1.0&q=85',
    'https://images.pexels.com/photos/37273678/pexels-photo-37273678.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600',
    'https://images.pexels.com/photos/35550981/pexels-photo-35550981.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600',
  ],
  hero_title_line1: 'Donde los negocios crecen',
  hero_title_line2: 'y las experiencias perduran',
  hero_subtitle: 'Experiencias exclusivas que unen golf, vino y networking en los rincones más singulares de España.',
  about_title: 'El club empresarial de los amantes del golf y el vino',
  about_text: 'Haz tus contactos en el mejor de los escenarios y mientras disfrutas de una gran experiencia alrededor del golf y del vino.',
  contact_phone: '(+34) 626 124 401',
  contact_email: 'golfdivino@gmail.com',
  contact_address: 'Jerez de la Frontera, Cádiz · España',
  social_instagram: 'https://www.instagram.com/golfdivino/',
  social_facebook: 'https://www.facebook.com/golfdivino',
  social_linkedin: 'https://www.linkedin.com/company/golfdivino/',
  quienes_intro: '',
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const s = await getSettings();
      setSettings({ ...DEFAULTS, ...s });
    } catch (_) {}
    setLoaded(true);
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loaded, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
